import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "qrcanva" ]

  connect() {
    const connection = this.connection = Symbol();
      
    var opts = {  
      errorCorrectionLevel: 'M',
      quality: 1,
      margin: 2,
      width: 250,
      color: {
        dark:"#c32fa0",
        light:"#F1F1F1"
      }
    }

    import('qrcode').then(({ default: QRCode }) => {
      if (this.connection !== connection) return;
      return QRCode.toCanvas(this.qrcanvaTarget, this.data.get("url"), opts);
    }).catch(() => {
      if (this.connection !== connection) return;
      window.alert("Could not create your QR code. Please close and reopen this dialog to try again.");
    });
  }

  disconnect() {
    this.connection = null;
  }
}
